// Import model
import { CeramicTileCatalogItemCondition } from '../models/CeramicTileCatalogItemCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { CeramicTileCatalogItemIndexedFields } from '../models/CeramicTileCatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { CeramicTileCatalogItemIndexedFieldsSerializer } from './CeramicTileCatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CeramicTileCatalogItemCondition - handles JSON serialization and deserialization with type validation
 */
export class CeramicTileCatalogItemConditionSerializer {
  /**
   * Deserializes a JSON string into a CeramicTileCatalogItemCondition instance
   */
  static deserialize(json: string): CeramicTileCatalogItemCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CeramicTileCatalogItemCondition instance
   */
  static fromObject(obj: any): CeramicTileCatalogItemCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CeramicTileCatalogItemCondition');
    }


    const instance: CeramicTileCatalogItemCondition = {
      fieldName: obj['fieldName'] as CeramicTileCatalogItemIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CeramicTileCatalogItemCondition instances
   */
  static deserializeArray(json: string): CeramicTileCatalogItemCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CeramicTileCatalogItemCondition instance to a JSON string
   */
  static serialize(instance: CeramicTileCatalogItemCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CeramicTileCatalogItemCondition instance to a plain object
   */
  static toObject(instance: CeramicTileCatalogItemCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of CeramicTileCatalogItemCondition instances to a JSON string
   */
  static serializeArray(instances: CeramicTileCatalogItemCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
